import React from 'react';
import PropTypes from 'prop-types';

import { formatPriceForDisplay } from '../../../../util/format-money';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currencySymbol: PropTypes.string.isRequired,
};

const PriceBreakdownRow = ({ label, value, currencySymbol }) => {
  return (
    <div className="price-breakdown-row" key={label}>
      <span className="price-breakdown-label">{label}</span>
      <span className="price-breakdown-value">
        {currencySymbol}
        {formatPriceForDisplay(value, false)}
      </span>
    </div>
  );
};

PriceBreakdownRow.propTypes = propTypes;

export default PriceBreakdownRow;
